import {Vector2} from "api/types/sketch";
import { getDistantPoint } from "../math";

export function drawLineHighlight(path: Path2D, start_vertex: Vector2, end_vertex: Vector2, angle: number){
    const start: Vector2 = getDistantPoint(start_vertex, angle - 180, 3);
    const end: Vector2 = getDistantPoint(end_vertex, angle - 180, 3);
    path.moveTo(start.X, start.Y);
    path.lineTo(end.X, end.Y);
}